import React from 'react';
// import firebase from "firebase/app";
// import "firebase/analytics";
// import { useTranslation } from "react-i18next";
import {
  useParams
} from "react-router-dom";
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
// import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import { Close, CheckCircleRounded, HelpOutlineRounded } from '@material-ui/icons';
import Snackbar from '@material-ui/core/Snackbar';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

// import SwitchLanguage from './components/switchLanguage';
import Config from './config';
import { checkMobileNumber, ValidateEmail } from './utils';
import { Divider } from '@material-ui/core';

// firebase.initializeApp(Config.firebaseConfig);
// const analytics = firebase.analytics();

moment.locale('au');

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    height: '100vh',
    backgroundColor: '#FFF',
  },
  header: {
    // display: 'flex',
    // flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
  completeHeader: {
    // display: 'flex',
    // flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(4),
  },
  headerInvalidStore: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flfex-start',
    padding: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
  logo: {
    width: theme.spacing(9),
    height: theme.spacing(9),
    marginBottom: theme.spacing(2),
  },
  language: {
    position: 'absolute',
    right: 3,
    top: 3,
  },
  form: {
    '& > *': {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    textAlign: 'center',
    minWidth: 280,
    maxWidth: 340,
    margin: '0 auto',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),

  },
  formControl: {
    width: 300,
    backgroundColor: '#FFF',
  },
  button: {
    width: 300,
    height: 56,
    margin: '0 auto',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    // color: '#FFF',
    fontSize: 18,
  },
  orderButton: {
    width: 200,
    height: 40,
    margin: '0 auto',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(3),
  },
}));

function CustomerRegister({ analytics }: { analytics: any }) {
  // const { t } = useTranslation();
  const classes = useStyles();
  const { storeId, tableId, validationCode, tableCode }: { storeId: string, tableId: string, validationCode: string, tableCode: string } = useParams();

  const [firstName, setFirstName] = React.useState<string>(localStorage.getItem('firstName') || '');
  const [lastName, setLastName] = React.useState<string>(localStorage.getItem('lastName') || '');
  const [mobile, setMobile] = React.useState<string>(localStorage.getItem('mobile') || '');
  const [email, setEmail] = React.useState<string>(localStorage.getItem('email') || '');
  const [snackbarOpen, setSnackbarOpen] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState<string>();
  const [storeDetail, setStoreDetail] = React.useState<any>();
  const [regisiterCompleted, setRegisiterCompleted] = React.useState<boolean>(false);
  const [invalidStore, setInvalidStore] = React.useState<boolean>(false);
  const [saveCustomerInfo, setSaveCustomerInfo] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (storeId && storeId.length === 36) {
      fetchStoreDetail();
    } else {
      console.error('Invalid Store Id');
      setInvalidStore(true);
    }
  }, []);

  const handleSubmit = () => {
    setErrorMessage('');
    if (!firstName.trim() || !lastName.trim() || !mobile.trim() || !email.trim()) {
      setErrorMessage('Please enter all required information');
      setSnackbarOpen(true);
      return;
    }
    if (!checkMobileNumber(mobile.trim())) {
      setErrorMessage('Please enter a valid mobile number');
      setSnackbarOpen(true);
      return;
    }
    if (!ValidateEmail(email.trim())) {
      setErrorMessage('Please enter a valid email address');
      setSnackbarOpen(true);
      return;
    }
    regisiter();
  }

  const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const regisiter = async () => {
    try {
      const regisiterResponse = await fetch(`${Config.apiUrl}store/v3/customer/register`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            firstName: firstName.trim(), lastName: lastName.trim(), mobile: mobile.trim(), storeId, email: email.trim()
          })
        }
      );
      if (!regisiterResponse.ok) {
        let message = `An error has occured: ${regisiterResponse.status}`;
        throw new Error(message);
      }
      console.log('regisiter success');
      analytics().logEvent('customer_regisiter_success', { storeId });
      if (saveCustomerInfo) {
        localStorage.setItem('firstName', firstName.trim());
        localStorage.setItem('lastName', lastName.trim());
        localStorage.setItem('mobile', mobile.trim());
        localStorage.setItem('email', email.trim());
      } else {
        localStorage.removeItem('firstName');
        localStorage.removeItem('lastName');
        localStorage.removeItem('mobile');
        localStorage.removeItem('email');
      }

      setRegisiterCompleted(true);

    } catch (error) {
      console.error(error.message)
      setErrorMessage(error.message);
      setSnackbarOpen(true);
    }
  };

  const fetchStoreDetail = async () => {
    try {
      const storeResponse = await fetch(`${Config.apiUrl}store/profile/${storeId}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      if (!storeResponse.ok) {
        let message = `An error has occured: ${storeResponse.status}`;
        throw new Error(message);
      }
      const storeDetailData = await storeResponse.json();
      setStoreDetail(storeDetailData.storeDetail);

    } catch (error) {
      console.error(error.message)
      setInvalidStore(true);
    }
  };

  const handleOrderNow = () => {
    setTimeout(function () { document.location.href = `${Config.linkOrderDomain}menu/placeholder?storeId=${storeId}&tableId=${tableId}&validationCode=${validationCode}&tableCode=${tableCode}`; }, 250);
  }

  if (invalidStore) {
    return (
      <div className={classes.root}>
        <Container maxWidth="sm" className={classes.headerInvalidStore}>
          <HelpOutlineRounded htmlColor='#eb5050' style={{ fontSize: 60, marginBottom: 20, marginTop: 80, }} />
          <Typography variant="h6" component="h1" >Oops! Please scan a valid Qrode.</Typography>
          <Typography variant="caption" component="p" style={{ marginTop: 30, }} >
            © {(new Date()).getFullYear} Link Tech, Inc. All rights reserved
        </Typography>
        </Container>
      </div >
    )
  }

  return (
    <div className={classes.root}>
      {/* <div className={classes.language}><SwitchLanguage /></div> */}
      {regisiterCompleted ?
        <Container className={classes.completeHeader}>
          <React.Fragment>
            <Typography variant="body2" component="p" style={{}} >Hi {firstName}, welcome to</Typography>
            <Typography variant="h6" component="h2" style={{ fontSize: 24, marginBottom: 15 }} >{storeDetail.name}</Typography>
          </React.Fragment>
          <Divider />
          <Typography variant="h3" component="h1" style={{ color: 'black', marginTop: 20, fontSize: 30 }} >
            Thank you!
            </Typography>
          <Typography variant="body2" component="p" style={{ color: 'black', marginTop: 20 }} >
            Your check in has been recorded. <br /> Please show this to one of our team before closing the window and enjoy your visit.
            </Typography>
          <CheckCircleRounded htmlColor='#0DDD7E' style={{ fontSize: 200, marginBottom: 20, marginTop: 30, }} />
          <Typography variant="h6" component="h2" style={{ fontSize: 24, marginBottom: 10 }} >
            {moment().format('LT')}
          </Typography>

          <Typography variant="body2" component="p" style={{ color: 'black', marginTop: 10 }} >
            {moment().format('dddd DD MMMM YYYY')}
          </Typography>
          {(tableId && validationCode && tableCode) ?
            <Button
              onClick={handleOrderNow}
              variant="contained"
              color="primary"
              disableElevation
              className={classes.orderButton}
            >
              Order Now
            </Button>
            : null}
        </Container>
        : null}

      {!regisiterCompleted ?
        <React.Fragment>
          <Container className={classes.header}>
            {(storeDetail) ?
              <React.Fragment>
                {/* <Avatar alt={storeDetail.name} src={storeDetail.logoImgUrl || Config.storeLogoUrl} className={classes.logo} /> */}
                <Typography variant="body2" component="p" style={{}} >Welcome to</Typography>

                <Typography variant="h6" component="h2" style={{ fontSize: 24, marginBottom: 15 }} >{storeDetail.name}</Typography>
              </React.Fragment>
              : null}
            <Divider />
            <Typography variant="h3" component="h1" style={{ color: 'black', marginTop: 20, fontSize: 30 }} >
              Guest Registration
            </Typography>
            <Typography variant="body2" component="p" style={{ color: 'black', marginTop: 20 }} >
              As a government requirement, we thank you for completing all fields below.
            </Typography>
          </Container>
          <div className={classes.form}>
            <TextField
              color="secondary"
              fullWidth
              className={classes.formControl}
              autoComplete="given-name"
              required id="firstName"
              label="First Name"
              variant="outlined"
              value={firstName}
              onChange={e => setFirstName(e.target.value)}
            />
            <TextField
              color="secondary"
              fullWidth
              className={classes.formControl}
              autoComplete="family-name"
              required id="lastName"
              label="Last Name"
              variant="outlined"
              value={lastName}
              onChange={e => setLastName(e.target.value)}
            />
            <TextField
              color="secondary"
              type="number"
              fullWidth
              className={classes.formControl}
              autoComplete="tel"
              required id="mobile"
              label="Mobile"
              variant="outlined"
              value={mobile}
              onChange={e => setMobile(e.target.value)}
            />
            <TextField
              color="secondary"
              type="email"
              fullWidth
              className={classes.formControl}
              autoComplete="email"
              required id="email"
              label="Email"
              variant="outlined"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
            <FormControlLabel control={<Switch
              checked={saveCustomerInfo}
              color="primary"
              onChange={() => setSaveCustomerInfo(!saveCustomerInfo)}
              name="saveCustomerInfo"
              inputProps={{ 'aria-label': 'secondary checkbox' }}
            />} label={
              <Typography variant="body2" component="p" style={{ color: 'black' }} >
                Remember my details
            </Typography>
            } />

            <Button
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              disableElevation
              size="large"
              className={classes.button}
            >
              CHECK IN
        </Button>
          </div>
        </React.Fragment>
        : null}
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleClose}
        message={errorMessage}
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={() => setSnackbarOpen(false)}>
              <Close fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    </div >
  );
}

export default CustomerRegister;
